const localeMappingList = [
    {
        locale: 'sv-se',
        flag: 'SE',
        language: 'Swedish',
        vrboCountry: 'Vrbo Sweden'
    },
    {
        locale: 'en-gb',
        flag: 'GB',
        language: 'English',
        vrboCountry: 'Vrbo UK'
    },
    {
        locale: 'de-de',
        flag: 'DE',
        language: 'German',
        vrboCountry: 'Vrbo Germany'
    },
    {
        locale: 'en-ca',
        flag: 'CA',
        language: 'English',
        vrboCountry: 'Vrbo Canada'
    },
    {
        locale: 'fr-ca',
        flag: 'CA',
        language: 'French',
        vrboCountry: 'Vrbo Canada'
    },
    {
        locale: 'en-sg',
        flag: 'SG',
        language: 'English',
        vrboCountry: 'Vrbo Singapore'
    },
    {
        locale: 'en-us',
        flag: 'US',
        language: 'English',
        vrboCountry: 'Vrbo US'
    },
    {
        locale: 'es-es',
        flag: 'ES',
        language: 'Spanish',
        vrboCountry: 'Vrbo España'
    },
    {
        locale: 'nl-nl',
        flag: 'NL',
        language: 'Dutch',
        vrboCountry: 'Vrbo Nederland'
    }
];

export const findByLocale = locale => localeMappingList.find(
    loc => String(loc.locale) === String(locale)
);

export default {
    findByLocale
};
